// Вопрос человеку модалкой вместо нативного confirm(): тот не стилизуется и выглядит чужим.
// Правило проекта: вопросы и предупреждения — модалки, сообщения о сбое — тост (CLAUDE.md).
// Спрашивалка модульная, как у сторожа даты выхода: одна на приложение, <ConfirmHost/> в app.tsx.
import { useEffect, useState, type ReactNode } from 'react';
import { Button } from './Button';
import { Modal } from './Modal';

export type ConfirmQuestion = {
  title: string;
  /** Текст вопроса; акценты — <b>, строки — абзацами. */
  text: ReactNode;
  /** Подпись кнопки согласия; по умолчанию Yes. */
  yes?: string;
  /** Опасное действие — кнопка красная. */
  danger?: boolean;
};

let asker: ((q: ConfirmQuestion) => Promise<boolean>) | null = null;
let asking = false;

/** Спросить и дождаться ответа; без смонтированного ConfirmHost или при открытом вопросе — false. */
export function confirmDialog(q: ConfirmQuestion): Promise<boolean> {
  if (!asker || asking) return Promise.resolve(false);
  asking = true;
  return asker(q).finally(() => { asking = false; });
}

export function ConfirmHost() {
  const [pending, setPending] = useState<{ q: ConfirmQuestion; resolve: (ok: boolean) => void } | null>(null);
  useEffect(() => {
    asker = (q) => new Promise((resolve) => setPending({ q, resolve }));
    return () => { asker = null; };
  }, []);
  if (!pending) return null;
  const { q, resolve } = pending;
  const answer = (ok: boolean) => { setPending(null); resolve(ok); };
  return (
    <Modal open onClose={() => answer(false)} title={q.title} footer={
      <div className="flex items-center gap-2" data-confirm-dialog>
        <span className="ml-auto" />
        <Button variant="ghost" onClick={() => answer(false)}>Cancel</Button>
        <Button variant={q.danger ? 'danger' : 'primary'} autoFocus onClick={() => answer(true)}>{q.yes ?? 'Yes'}</Button>
      </div>
    }>
      <div className="text-base [&_b]:font-semibold [&_p+p]:mt-2">{q.text}</div>
    </Modal>
  );
}
